import DeleteModal from '@components/common/DeleteModal';
import React from 'react';

import useCollectionParams from '@app/hooks/useCollectionParams';
import {bool, func, object} from 'prop-types';
import {deselectFeatureRef} from '@actions/selected-features';
import {notify} from '@actions/notifications';
import {setCollectionVisibility} from '@app/actions/collections';
import {trackEvent} from '@app/analytics';
import {useDeleteCollection} from '@app/api/collections';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';

const EVENT_NAME = 'Delete Collection Modal';

const DeleteCollectionModal = ({open, onClose, collection}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {collectionId: activeCollectionId, resetCollection} =
    useCollectionParams();

  const {mutate: deleteCollection, isPending: isDeletingCollection} =
    useDeleteCollection({
      onSuccess: () => {
        trackEvent(EVENT_NAME, {
          action: 'Deleted collection',
        });
        onClose();
        if (activeCollectionId) {
          resetCollection();
          dispatch(deselectFeatureRef());
        }
        dispatch(setCollectionVisibility({collection, visible: false}));
      },
      onError: () => {
        dispatch(
          notify({
            severity: 'error',
            message: t('deleteModal.error'),
          })
        );
      },
    });

  const onDelete = () => {
    deleteCollection({collectionId: collection.id});
  };

  const handleOnClose = () => {
    trackEvent(EVENT_NAME, {
      action: 'closed modal',
    });

    onClose();
  };

  return (
    <DeleteModal
      open={open}
      onClose={handleOnClose}
      title={t('deleteModal.deleteCollectionTitle')}
      description={t('deleteModal.deleteCollectionDescription')}
      isPending={isDeletingCollection}
      onDelete={onDelete}
    />
  );
};

DeleteCollectionModal.propTypes = {
  collection: object,
  onClose: func,
  open: bool,
};

export default DeleteCollectionModal;
